// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles */
body {
    margin: 0;
    padding: 0;
    font-family: 'Poppins', sans-serif;
    background-color: #f9f9f9;
    color: #333;
}

section#about{
    width: 50%;
    margin: 10rem auto;
}

h1 {
    margin: 0;
    font-size: 1.8rem;
}

/* Navbar */
.navbar {
    background-color: #594BF8;
    padding: 0.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    font-size: 1.8rem;
    width: 100%;
    box-sizing: border-box;
}

.navbar button {
    background-color: #009BFD;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    border: none;
    color: white;
    cursor: pointer;
}

.navbar button:hover {
    background-color: #000000;
}

/* Main content area */
.main-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100vw;
    padding: 20px;
    box-sizing: border-box;
}

/* Left column (form section) */
.textarea-container {
    flex: 1 1;
    padding: 1rem;
}

/* Wheel text style */
.wheel-container text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap; /* Prevent the text from wrapping */
  max-width: 90%;  /* Set the max width for the text element */
}

/* Textarea and Buttons */
.bulk-textarea {
    width: 90%;
    height: 40vh;
    margin-bottom: 1rem;
    padding: 0.8rem;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1rem;
    font-family: 'Poppins', sans-serif;
    resize: vertical;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Adjust button container to align buttons side by side */
.button-container {
    display: flex;
    justify-content: space-between;
    gap: 10px; /* Space between buttons */
    margin-top: 20px;
}

/* Reset and Spin Buttons */
.reset-button, .spin-button {
    width: 48%;
    padding: 1rem;
    font-size: 1.2rem;
    border: none;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
}

.reset-button {
    background-color: #ff6f61;
}

.reset-button:hover {
    background-color: #ff8579;
    transform: scale(1.05);
}

.spin-button {
    background-color: #ffa07a;
}

.spin-button:hover {
    background-color: #ff8f6b;
    transform: scale(1.05);
}

.reset-button[disabled], .spin-button[disabled] {
    background-color: #e0e0e0;
    cursor: not-allowed;
    transform: none;
}

/* Wheel container */
.wheel-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative; /* For absolute positioning of the pointer */
    height: 70vh;
}

.wheel-container svg {
    width: 100%;  /* Wheel takes full width */
    height: auto;
    z-index: 0;
}

/* CSS for the pointer to adjust dynamically */
.wheel-pointer {
  position: absolute;
  top: 15px; /* Adjust it to sit outside and above the wheel */
  margin-left: -18px;
  left: 50%; /* Center horizontally */
  z-index: 10; /* Ensure the pointer is above the wheel */
  width: 0;
  height: 0;
  border-left: 1rem solid transparent;
  border-right: 1rem solid transparent;
  border-bottom: 2rem solid #000000;
  transform: rotate(180deg); /* Points downwards */
}

/* Winners list styling */
.winners-container {
    margin-top: 20px;
    padding: 10px;
    background-color: #f7f7f7;
    border-radius: 5px;
}

.winners-container h2 {
    margin-bottom: 10px;
}

.winners-container ol {
    margin: 0;
    padding-left: 20px;
}

.winners-container li {
    font-size: 16px;
    color: #333;
}

/* Popup modal styles */
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}

.modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 2rem 3rem;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    z-index: 2000;
    width: 80%; /* Default width */
    max-width: 500px; /* Max width */
    text-align: center;
}

.modal-content h2 {
    font-size: 2.2rem;
    margin-bottom: 1.5rem;
    color: #333;
    font-weight: 600;
}

.modal-content p {
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    color: #555;
    font-weight: 400;
}

.modal-buttons {
    display: flex;
    justify-content: center;
    gap: 20px;
}

.modal-button {
    padding: 1rem 2rem;
    border: none;
    border-radius: 8px;
    font-size: 1.2rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s ease-in-out;
}

.remove-button {
    background-color: #ff6f61;
    color: white;
}

.remove-button:hover {
    background-color: #ff8579;
    transform: scale(1.05);
}

.keep-button {
    background-color: #6fc3df;
    color: white;
}

.keep-button:hover {
    background-color: #8dd6f0;
    transform: scale(1.05);
}

/* Mobile layout adjustments */
@media (max-width: 768px) {
    .main-content {
        flex-direction: column-reverse;  /* Stack elements on top of each other */
        align-items: center;
    }

    .wheel-container {
        margin-top: 10px;
        height: 50vh;  /* Wheel height adjusted for mobile */
    }

    .wheel-container svg {
        width: 100%;  /* Full width for the wheel */
        height: auto;
    }

    .modal {
        width: 70%; /* Adjust width for mobile */
        padding: 1.5rem; /* Adjust padding for smaller screens */
    }

    .modal p{
        display: none;
    }

    .wheel-pointer {
      left: 50%;
      margin-left: -18px; /* Adjust the pointer's position for smaller screens */
    }

    .winners-container {
        margin-top: 20px;
        width: 100%;  /* Full width for the winners list */
    }

    .textarea-container {
        width: 100%;  /* Full width for the textarea on mobile */
        padding: 20px;
    }

    .button-container {
        display: flex;
        flex-direction: column;  /* Stack buttons vertically */
        gap: 10px;
        width: 100%;  /* Full width for buttons */
    }

    .reset-button, .spin-button {
        width: 100%;  /* Full width for each button */
    }
}

@media (min-width: 769px) and (max-width: 1024px) {
    .main-content {
        flex-direction: row;
        justify-content: space-between;
    }

    .wheel-container {
        margin-top: 20px;
        height: 70vh;
    }

    .wheel-container svg {
        width: 80%;  /* Wheel width on tablet */
        height: auto;
    }

    .textarea-container {
        width: 35%;
    }

    .button-container {
        display: flex;
        justify-content: space-between;
        gap: 10px;
    }

    .reset-button, .spin-button {
        width: 48%;
    }
}

@media (min-width: 1025px) {
    .main-content {
        flex-direction: row;
        justify-content: space-evenly;
    }

    .wheel-container {
        height: 90vh;
    }

    .wheel-container svg {
        height: auto;
    }


    .textarea-container {
        max-width: 25%;
    }

    .button-container {
        display: flex;
        justify-content: space-between;
        gap: 10px;
    }

    .reset-button, .spin-button {
        width: 48%;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,SAAS;IACT,UAAU;IACV,kCAAkC;IAClC,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA,WAAW;AACX;IACI,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA,+BAA+B;AAC/B;IACI,SAAO;IACP,aAAa;AACjB;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB,EAAE,mCAAmC;EACxD,cAAc,GAAG,2CAA2C;AAC9D;;AAEA,yBAAyB;AACzB;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA,0DAA0D;AAC1D;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS,EAAE,0BAA0B;IACrC,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yEAAyE;AAC7E;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB,EAAE,4CAA4C;IAChE,YAAY;AAChB;;AAEA;IACI,WAAW,GAAG,2BAA2B;IACzC,YAAY;IACZ,UAAU;AACd;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,SAAS,EAAE,iDAAiD;EAC5D,kBAAkB;EAClB,SAAS,EAAE,wBAAwB;EACnC,WAAW,EAAE,0CAA0C;EACvD,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;EACjC,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA,yBAAyB;AACzB;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,UAAU,EAAE,kBAAkB;IAC9B,gBAAgB,EAAE,cAAc;IAChC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,6DAA6D;AACjE;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,8BAA8B;AAC9B;IACI;QACI,8BAA8B,GAAG,wCAAwC;QACzE,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,YAAY,GAAG,qCAAqC;IACxD;;IAEA;QACI,WAAW,GAAG,6BAA6B;QAC3C,YAAY;IAChB;;IAEA;QACI,UAAU,EAAE,4BAA4B;QACxC,eAAe,EAAE,uCAAuC;IAC5D;;IAEA;QACI,aAAa;IACjB;;IAEA;MACE,SAAS;MACT,kBAAkB,EAAE,sDAAsD;IAC5E;;IAEA;QACI,gBAAgB;QAChB,WAAW,GAAG,oCAAoC;IACtD;;IAEA;QACI,WAAW,GAAG,0CAA0C;QACxD,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB,GAAG,6BAA6B;QACtD,SAAS;QACT,WAAW,GAAG,2BAA2B;IAC7C;;IAEA;QACI,WAAW,GAAG,+BAA+B;IACjD;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,UAAU,GAAG,0BAA0B;QACvC,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,6BAA6B;IACjC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;;IAGA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":["/* Base styles */\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: 'Poppins', sans-serif;\n    background-color: #f9f9f9;\n    color: #333;\n}\n\nsection#about{\n    width: 50%;\n    margin: 10rem auto;\n}\n\nh1 {\n    margin: 0;\n    font-size: 1.8rem;\n}\n\n/* Navbar */\n.navbar {\n    background-color: #594BF8;\n    padding: 0.4rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: white;\n    font-size: 1.8rem;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.navbar button {\n    background-color: #009BFD;\n    padding: 0.5rem 1rem;\n    font-size: 1rem;\n    border: none;\n    color: white;\n    cursor: pointer;\n}\n\n.navbar button:hover {\n    background-color: #000000;\n}\n\n/* Main content area */\n.main-content {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 100vw;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n/* Left column (form section) */\n.textarea-container {\n    flex: 1;\n    padding: 1rem;\n}\n\n/* Wheel text style */\n.wheel-container text {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap; /* Prevent the text from wrapping */\n  max-width: 90%;  /* Set the max width for the text element */\n}\n\n/* Textarea and Buttons */\n.bulk-textarea {\n    width: 90%;\n    height: 40vh;\n    margin-bottom: 1rem;\n    padding: 0.8rem;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 1rem;\n    font-family: 'Poppins', sans-serif;\n    resize: vertical;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Adjust button container to align buttons side by side */\n.button-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px; /* Space between buttons */\n    margin-top: 20px;\n}\n\n/* Reset and Spin Buttons */\n.reset-button, .spin-button {\n    width: 48%;\n    padding: 1rem;\n    font-size: 1.2rem;\n    border: none;\n    border-radius: 8px;\n    color: white;\n    cursor: pointer;\n    transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;\n}\n\n.reset-button {\n    background-color: #ff6f61;\n}\n\n.reset-button:hover {\n    background-color: #ff8579;\n    transform: scale(1.05);\n}\n\n.spin-button {\n    background-color: #ffa07a;\n}\n\n.spin-button:hover {\n    background-color: #ff8f6b;\n    transform: scale(1.05);\n}\n\n.reset-button[disabled], .spin-button[disabled] {\n    background-color: #e0e0e0;\n    cursor: not-allowed;\n    transform: none;\n}\n\n/* Wheel container */\n.wheel-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative; /* For absolute positioning of the pointer */\n    height: 70vh;\n}\n\n.wheel-container svg {\n    width: 100%;  /* Wheel takes full width */\n    height: auto;\n    z-index: 0;\n}\n\n/* CSS for the pointer to adjust dynamically */\n.wheel-pointer {\n  position: absolute;\n  top: 15px; /* Adjust it to sit outside and above the wheel */\n  margin-left: -18px;\n  left: 50%; /* Center horizontally */\n  z-index: 10; /* Ensure the pointer is above the wheel */\n  width: 0;\n  height: 0;\n  border-left: 1rem solid transparent;\n  border-right: 1rem solid transparent;\n  border-bottom: 2rem solid #000000;\n  transform: rotate(180deg); /* Points downwards */\n}\n\n/* Winners list styling */\n.winners-container {\n    margin-top: 20px;\n    padding: 10px;\n    background-color: #f7f7f7;\n    border-radius: 5px;\n}\n\n.winners-container h2 {\n    margin-bottom: 10px;\n}\n\n.winners-container ol {\n    margin: 0;\n    padding-left: 20px;\n}\n\n.winners-container li {\n    font-size: 16px;\n    color: #333;\n}\n\n/* Popup modal styles */\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n}\n\n.modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: #fff;\n    padding: 2rem 3rem;\n    border-radius: 16px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n    z-index: 2000;\n    width: 80%; /* Default width */\n    max-width: 500px; /* Max width */\n    text-align: center;\n}\n\n.modal-content h2 {\n    font-size: 2.2rem;\n    margin-bottom: 1.5rem;\n    color: #333;\n    font-weight: 600;\n}\n\n.modal-content p {\n    font-size: 1.2rem;\n    margin-bottom: 1.5rem;\n    color: #555;\n    font-weight: 400;\n}\n\n.modal-buttons {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n}\n\n.modal-button {\n    padding: 1rem 2rem;\n    border: none;\n    border-radius: 8px;\n    font-size: 1.2rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s, transform 0.2s ease-in-out;\n}\n\n.remove-button {\n    background-color: #ff6f61;\n    color: white;\n}\n\n.remove-button:hover {\n    background-color: #ff8579;\n    transform: scale(1.05);\n}\n\n.keep-button {\n    background-color: #6fc3df;\n    color: white;\n}\n\n.keep-button:hover {\n    background-color: #8dd6f0;\n    transform: scale(1.05);\n}\n\n/* Mobile layout adjustments */\n@media (max-width: 768px) {\n    .main-content {\n        flex-direction: column-reverse;  /* Stack elements on top of each other */\n        align-items: center;\n    }\n\n    .wheel-container {\n        margin-top: 10px;\n        height: 50vh;  /* Wheel height adjusted for mobile */\n    }\n\n    .wheel-container svg {\n        width: 100%;  /* Full width for the wheel */\n        height: auto;\n    }\n\n    .modal {\n        width: 70%; /* Adjust width for mobile */\n        padding: 1.5rem; /* Adjust padding for smaller screens */\n    }\n\n    .modal p{\n        display: none;\n    }\n\n    .wheel-pointer {\n      left: 50%;\n      margin-left: -18px; /* Adjust the pointer's position for smaller screens */\n    }\n\n    .winners-container {\n        margin-top: 20px;\n        width: 100%;  /* Full width for the winners list */\n    }\n\n    .textarea-container {\n        width: 100%;  /* Full width for the textarea on mobile */\n        padding: 20px;\n    }\n\n    .button-container {\n        display: flex;\n        flex-direction: column;  /* Stack buttons vertically */\n        gap: 10px;\n        width: 100%;  /* Full width for buttons */\n    }\n\n    .reset-button, .spin-button {\n        width: 100%;  /* Full width for each button */\n    }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n    .main-content {\n        flex-direction: row;\n        justify-content: space-between;\n    }\n\n    .wheel-container {\n        margin-top: 20px;\n        height: 70vh;\n    }\n\n    .wheel-container svg {\n        width: 80%;  /* Wheel width on tablet */\n        height: auto;\n    }\n\n    .textarea-container {\n        width: 35%;\n    }\n\n    .button-container {\n        display: flex;\n        justify-content: space-between;\n        gap: 10px;\n    }\n\n    .reset-button, .spin-button {\n        width: 48%;\n    }\n}\n\n@media (min-width: 1025px) {\n    .main-content {\n        flex-direction: row;\n        justify-content: space-evenly;\n    }\n\n    .wheel-container {\n        height: 90vh;\n    }\n\n    .wheel-container svg {\n        height: auto;\n    }\n\n\n    .textarea-container {\n        max-width: 25%;\n    }\n\n    .button-container {\n        display: flex;\n        justify-content: space-between;\n        gap: 10px;\n    }\n\n    .reset-button, .spin-button {\n        width: 48%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
